<template>
  <div class="wholeContext chatbot">
    <div class="appContext chatbot">
      <div class="container">
        <div class="area_wrap chat" :style="{height:screenHeight}">
          <div class="chat_header">
            <div class="ch_imgWrap" @click="chatInit()">
              <img src="@/assets/images/back.svg">
            </div>
            <div class="ch_txt">
              <img src="@/assets/images/chat_logo.svg">
              <p>보통 수십 분 내에 응답합니다.</p>
            </div>
<!--            <div class="ch_closeBtn">-->
<!--              <img src="@/assets/images/x_white.svg">-->
<!--            </div>-->
          </div>
          <div class="chat_body">
            <div class="chat_date">
              <p id="date"></p>
            </div>
            <div class="chat_wrap">
              <div class="response">
                <div class="cw_header">
                  <span class="cw_logo">
                    <img src="@/assets/images/chat_q.svg">
                  </span>
                  <div class="cw_title">
                    <p>땡큐이비인후과</p>
                    <p class="time" id="time"></p>
                  </div>
                </div>
                <div class="cw_space">
                  <div class="space_content">
                    <p>안녕하세요</p>
                    <p>땡큐 이비인후과 입니다!</p>
                    <br>
                    <p>간단한 문의는 아래 서포트 봇으로 보다 쉽고 빠르게 답변을 </p>
                    <p>확인하실 수 있습니다.</p>
                    <br>
                    <p>병원 운영시간</p>
                    <p>월~금: 오전 10시~오후 7시</p>
<!--                    <div class="chat_btn">-->
<!--                      <router-link to="/info/wayInfo">-->
<!--                        <button>오시는길 바로가기</button>-->
<!--                      </router-link>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
              <div class="format">
                <beat-loader :loading="loader.loading" :color="loader.color" :size="loader.size"></beat-loader>
              </div>
            </div>
          </div>
          <div class="chat_footer">
            <div class="errorWrap" v-if="errorFlag">
              <span>메시지를 전송하지 못했습니다.</span>
            </div>
            <div class="send_wrap">
              <form @submit.prevent="init()">
                <textarea type="text" placeholder="메시지를 입력해주세요." v-model="queryString" ref="queryString"></textarea>
                <div class="sw_imgWrap">
                  <button type="submit" :disabled="!inputError">
                    <img :src="inputError ? require(`@/assets/images/${imgOn}`) : require(`@/assets/images/${imgUn}`)">
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { hasNotch, NOTCH_HEIGHT } from '../../utils/checkDevice'

export default {
  props: {
  },
  components: {
    BeatLoader,
    AddPopup
  },
  data () {
    return {
      screenHeight: '100%',
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      loader: {
        loading: false,
        color: '#ff6565',
        size: '15px'
      },
      queryString: '',
      inputError: false,
      imgOn: 'send_on.svg',
      imgUn: 'send_un.svg',
      errorFlag: false,
      chatbot: [{
        images: [],
        buttons: [],
        links: [{
          url: '',
          title: '',
          subTitle: ''
        }],
        linkFlag: false,
        reply: ''
      }]
    }
  },
  mounted () {
    this.screenHeight = hasNotch() ? (screen.height - NOTCH_HEIGHT) + 'px' : screen.height + 'px'
    const date = document.getElementById('date')
    const time = document.getElementById('time')
    const today = new Date()
    const dateFormat = this.$moment(today).format('YYYY-MM-DD')
    const timeFormat = this.$moment(today).format('LT')
    date.innerText = dateFormat
    time.innerText = timeFormat
    this.$refs.queryString.focus()
  },
  watch: {
    queryString (val) {
      this.inputError = !!val.trim().length
    }
  },
  computed: {
    ...mapGetters('chatbot', [
      'getChat'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_CHAT',
      'SET_POPUP'
    ]),
    ...mapActions('chatbot', [
      'CHAT_BOT'
    ]),
    chatInit () {
      this.SET_POPUP(true)
      this.popupSet.topImg = true
      this.popupSet.content = '<h2>챗봇상담 종료</h2> <p>챗봇상담 종료 시 </p> <p>상담 내용은 저장되지 않습니다.</p>'
      this.popupSet.nextLink = '/'
      this.popupSet.count = 'double'
      this.popupSet.cancelBtnText = '취소'
      this.popupSet.confirmBtnText = '종료'
      this.popupSet.closeType = 'close'
    },
    init () {
      const msg = this.queryString
      console.log('msg: ', msg)
      this.creatMsgTag(msg)
    },
    creatMsgTag (msg) {
      const format = document.querySelector('.format')
      const request = document.createElement('div')
      request.classList.add('request')
      format.appendChild(request)
      let requestTime = new Date()
      requestTime = this.$moment(requestTime).format('LT')
      const appendHtml =
        '<div class="cw_header">' +
        '<div class="cw_title">' +
        `<p class="time">${requestTime}</p>` +
        '</div>' +
        '</div>' +
        '<div class="cw_space">' +
        '<div class="space_content">' +
        `<p>${msg}</p>` +
        '</div>' +
        '</div>'
      request.innerHTML = appendHtml
      /* 스크롤 하단으로 고정 */
      const chatBody = document.querySelector('.chat_body')
      chatBody.scrollTop = chatBody.scrollHeight
      this.loader.loading = true
      this.sendMsg()
    },
    async sendMsg () {
      // const str = document.querySelector('textarea')
      // str.value.split('\u21b5').join('')
      // console.log('str: ', str)
      // console.log('str: ', str.value)
      const data = {
        queryString: this.queryString
      }
      try {
        await this.CHAT_BOT(data)
          .then(() => {
            this.errorFlag = false
            const chat = this.getChat
            const format = document.querySelector('.format')
            const request = document.createElement('div')
            request.classList.add('request')
            const response = document.createElement('div')
            response.classList.add('response')
            format.appendChild(request)
            format.appendChild(response)
            const image = require('@/assets/images/chat_q.svg')
            let responseTime = new Date()
            responseTime = this.$moment(responseTime).format('LT')
            console.log('chat: ', chat)
            // const links = chat.links
            // if (links.length > 0) {
            //   for (let i = 0; i < links.length; i++) {
            //     console.log('links.length: ', links.length)
            //     console.log('링크있다')
            //     this.links = links[i]
            //     this.linkFlag = true
            //   }
            // } else {
            //   console.log('링크없다')
            //   this.links = []
            //   this.linkFlag = false
            // }
            // console.log('links: ', this.links)
            // console.log('links.url: ', this.links.url)
            for (let i = 0; i < chat.length; i++) {
              if (chat[i].links.length > 0) {
                for (let j = 0; j < chat[i].links.length; j++) {
                  console.log('link 있음')
                  console.log('chat.links: ', chat[i].links)
                  const appendResponse =
                    '<div class="cw_header">' +
                    '<span class="cw_logo">' +
                    `<img src=${image}>` +
                    '</span>' +
                    '<div class="cw_title">' +
                    '<p>땡큐이비인후과</p>' +
                    `<p class="time">${responseTime}</p>` +
                    '</div>' +
                    '</div>' +
                    '<div class="cw_space">' +
                    '<div class="space_content">' +
                    `<p>${chat[i].reply}</p>` +
                    '<div class="chat_btn">' +
                    `<a href="${chat[i].links[j].url}">` +
                    `<button>${chat[i].links[j].title}</button>` +
                    '</a>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                  response.innerHTML += appendResponse
                }
              } else {
                console.log('link 없음')
                const appendResponse =
                  '<div class="cw_header">' +
                  '<span class="cw_logo">' +
                  `<img src=${image}>` +
                  '</span>' +
                  '<div class="cw_title">' +
                  '<p>땡큐이비인후과</p>' +
                  `<p class="time">${responseTime}</p>` +
                  '</div>' +
                  '</div>' +
                  '<div class="cw_space">' +
                  '<div class="space_content">' +
                  `<p>${chat[i].reply}</p>` +
                  '</div>' +
                  '</div>'
                response.innerHTML += appendResponse
              }
            }
            document.querySelectorAll('.chat_btn').forEach((e) => {
              const text = e.childNodes[0].textContent
              if (text === 'undefined') {
                console.log('text: ', text)
                e.classList.add('hide')
              }
            })
            /* 스크롤 하단으로 고정 */
            const chatBody = document.querySelector('.chat_body')
            setTimeout(() => {
              chatBody.scrollTop = chatBody.scrollHeight
            }, 100)
          })
      } catch (error) {
        this.errorFlag = true
        this.loader.loading = false
        console.log('error :', error);
        console.log('챗봇 api에서 에러발생.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.queryString = ''
        this.$refs.queryString.focus()
        this.loader.loading = false
      }
    }
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  }

}
</script>

<style lang="scss" scoped>

:root {
    --sat: env(safe-area-inset-top);
    --sar: env(safe-area-inset-right);
    --sab: env(safe-area-inset-bottom);
    --sal: env(safe-area-inset-left);
}
</style>
